import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Resource } from './resource';
import { ApiParams } from './api-params';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@content-platform/web-angular-shared-util-logging";
import * as i3 from "./api-params";
export class UserRoleListResource extends Resource {
    constructor(http, logger, apiParams) {
        super(http, logger.instance('UserRoleListResource'));
        this.apiParams = apiParams;
    }
    getUrl() {
        return this.apiParams.getUrl('userRoles');
    }
    transformRequest(userRoleList) {
        const { id, name, uuid, modifiedDate, lastModifiedBy } = userRoleList;
        const roles = userRoleList.roles.map((role) => ({ id: role.id, name: role.name }));
        return { id, uuid, roles, name, modifiedDate, lastModifiedBy };
    }
    get entityName() {
        return 'User Role List';
    }
    static { this.ɵfac = function UserRoleListResource_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UserRoleListResource)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoggerService), i0.ɵɵinject(i3.ApiParams)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserRoleListResource, factory: UserRoleListResource.ɵfac }); }
}
//# sourceMappingURL=user-role-list-resource.js.map